export const path = {
  ADD_ARI_EDIT_RESPONSES: 'ari/intent/addintents?',
  ADD_CAMPAIGN: 'job/add?',
  ADD_CANDIDATE_API: 'candidate/add?',
  ADD_CANDIDATE_TAG: 'candidate/add_tag?',
  ADD_CANDIDATE_TO_CAMPAIGN: 'candidates/add_job?',
  ADD_CANDIDATE_TO_TAG: 'candidates/add_tag?',
  ADD_FACEBOOK_MAPPING: 'facebook/subscribe_page?',
  ADD_MOBILE_ACCOUNT: 'new_mobile_acct',
  ADD_PUSH_DEVICE: 'user/add_push_device',
  ADD_TAGS: 'tags/add?',
  ADD_ATS_CANDIDATE: 'candidates/add?',
  APPROVE_EMPLOYEE: 'invite/team_member/approve?',
  ARI_EDIT_RESPONSES: 'ari/intents/intentdata?',
  ARI_INTENTS_EXPORT: 'ari/intent/export?',
  BULK_CANDIDATE_ADD: 'candidates/bulkadd_job?',
  GET_TOS: '/tos',
  CONFIRM_TOS: '/tos/confirm',
  ARI_RESPONSES_IMPORT_FILE: 'ari/intent/response/import?',
  ARI_SEQUENCES: 'sequence/outbound_ari',
  AUTHENTICATE: 'user/authenticate?',
  AVAILIBILITY: 'availability?',
  AVAILIBILITY_UPDATE: 'availability/update?',
  BACKGROUND_EVENTS: 'backgroundevents?',
  CAMPAIGNS_API: 'jobs?',
  CAMPAIGNS_REPORT: 'reporting/campaigns',
  CAMPAIGN_API: 'job?',
  CAMPAIGN_CANDIDATES: 'job/candidates',
  CANCEL_MESSAGE: 'message/scheduled/cancel?',
  CANDIDATES: 'candidates?',
  CANDIDATES_IN_SEQUENCE: 'ari/candidates_in_sequence?',
  CANDIDATE_FILE_UPLOAD: 'file_import?',
  CANDIDATE_IMPORT_FILE: 'candidate/import?',
  CANDIDATE_JOB_MAX: 'candidate_job_max',
  CANDIDATE_METRICS_BY_ID: 'metrics/candidates?',
  CANDIDATE_QUERY: 'candidates',
  CHANGE_PASSWORD: 'user/change_password?',
  CLAIM_JOB_CHAT: 'jobchat/claim',
  CORE_MOBILE_VERSION: 'v1/textrecruit/core/mobile_version',
  CREATE_DLC_FORM: 'customer/ten_dlc',
  CUSTOMER: 'v1/textrecruit/customer',
  CUSTOMER_BASIC: 'v1/textrecruit/customer/basic',
  CUSTOMER_BILLING_CANCEL: 'v1/textrecruit/billing/cancel',
  CUSTOMER_BILLING_CARD_SET: 'v1/textrecruit/billing/card/set',
  CUSTOMER_BILLING_DETAILS: 'v1/textrecruit/billing/details',
  CUSTOMER_BILLING_SUBSCRIBE: 'v1/textrecruit/billing/subscribe',
  CUSTOMER_INT_ADD_UPDATE_TEMPLATE: 'customer/int/add_update_template?',
  CUSTOMER_INT_EVENTS: '/customer/int/events',
  CUSTOMER_INT_REMOVE_TEMPLATE: 'customer/int/remove_template?',
  CUSTOMER_INT_SAVE_FIELDS: 'customer/int/save_fields?',
  CUSTOMER_INT_TEMPLATES: 'customer/int/templates?',
  CUSTOMER_INVOICE: 'v1/textrecruit/customer/invoice',
  CUSTOMER_INVOICE_PAY: 'v1/textrecruit/customer/invoice/pay',
  CUSTOMER_MESSAGE_OPTIONS_UPDATE: 'customer/message_options/update?',
  CUSTOMER_SEND_TIME_RESTRICTION_UPDATE: 'customer/send_time_restriction/update?',
  CUSTOMER_STATS: 'v1/textrecruit/customer/stats',
  DELETE_CANDIDATES: 'candidates/scrub?',
  DISABLE_ARI: 'sequence/disable_ari?',
  DISCONNECT_CALENDAR: 'user/calendar/disconnect/',
  DO_NOT_TEXT: 'candidate/do_not_text?',
  EDIT_CAMPAIGN: 'job/update?',
  ENABLE_ARI: 'sequence/enable_ari?',
  EVENTS: 'events',
  GET_EVENT: 'event',
  GENERATE_EVENT_LINK: 'event/generate_events_link',
  FETCH_ARI_INTENTS: 'ari/intents',
  FETCH_VECTOR_SEARCH_RESULTS: 'ari/documents/search?',
  FINALIZE: 'v1/textrecruit/finalize',
  FORGOT_PASSWORD: 'user/forgot_password?',
  GET_ACTIVE_CHATS: 'jobchat/chats',
  ATS_USER: '/user/icims/person',
  INGEST_ATS_USER: '/user/icims/user/import?',
  GET_BASIC_CUSTOMER_INFO: 'customer/basic',
  GET_BASIC_USER: 'customer/basic?',
  GET_CANDIDATE_BY_ID: 'candidate?',
  GET_CANDIDATE_BY_PHONE: 'candidate_by_phone?',
  GET_CANDIDATE_BY_SOURCE: 'candidate_by_source?',
  GET_CHAT_AGENTS: 'jobchat/agents',
  GET_DLC_FORM: 'customer/getTenDlcRegistration',
  GET_MESSAGES_API: 'messages/related?',
  GET_SCHEDULED_MESSAGE: 'message/scheduled/get',
  GET_SEQUENCES: 'sequence/get_sequence?',
  GET_FACEBOOK_ACCOUNT_DETAILS: '/me',
  GET_FACEBOOK_PAGES: '/me/accounts',
  INTEGRATION_DATA: 'integration_data?',
  INVITE_TEMPLATES: 'invite/templates?',
  LOGIN: 'user/login',
  LOGOUT: 'user/logout',
  LOOKUP: 'lookup',
  MESSAGE: 'message?',
  MESSAGE_TEMPLATES: 'templates?',
  MESSAGE_THREADS: 'threads?',
  METRICS_CAMPAIGN: 'metrics/campaigns?',
  METRICS_CANDIDATE: 'v1/textrecruit/metrics/candidate',
  METRICS_CUSTOMER: 'v1/textrecruit/metrics/customers',
  METRICS_CUSTOMER_HOURLY: 'v1/textrecruit/metrics/customers/hourly',
  METRICS_REPORT: 'reporting/metrics',
  METRICS_REPORT_USERS: 'metrics/users?',
  METRICS_TEAMS: 'metrics/teams?',
  METRICS_TEAMS_HOURLY: 'v1/textrecruit/metrics/teams/hourly',
  METRICS_USERS: 'metrics/users',
  METRICS_USERS_HOURLY: 'metrics/users/hourly',
  METRICS_TEAMS_HOURLY_GRAPH: 'metrics/teams/hourly',
  MGR_USER: 'mgr/user',
  MGR_USERS: 'mgr/users',
  MGR_USERS_OMNI: 'mgr/users_omni',
  MGR_USER_ADD_INBOX: 'mgr/user/add_inbox?',
  MGR_USER_CREATE: 'mgr/user/create?',
  MGR_USER_DISABLE: 'mgr/user/disable?',
  MGR_USER_ENABLE: 'mgr/user/enable?',
  MGR_USER_EXPIRE_PASSWORD: 'mgr/user/expire_pw?',
  MGR_USER_IMPORT: 'mgr/user/import?',
  MGR_USER_INT_ICIMS_ADD_USER_ID: 'mgr/user/int/icims/add_user_id?',
  MGR_USER_INT_ICIMS_REMOVE_USER_ID: 'mgr/user/int/icims/remove_user_id?',
  MGR_USER_LICENSE_ADD: 'mgr/user/license/add?',
  MGR_USER_LICENSE_REMOVE: 'mgr/user/license/remove?',
  MGR_USER_REMOVE_INBOX: 'mgr/user/remove_inbox?',
  MGR_USER_REVOKE: 'mgr/user/revoke?',
  MGR_USER_UPDATE: 'mgr/user/update?',
  BULK_EDIT_TEAM_USERS: 'user/bulkusersteamupdate?',
  NEW_ACCOUNT: 'v1/textrecruit/new_account',
  OMNI_SEARCH: 'omni_search',
  OUTBOUND_ARI: 'sequence/outbound_ari?',
  RECOVER_PASSWORD: 'user/recover_password?',
  REFRESH_TOKEN: 'user/authenticate_uid?',
  REJECT_EMPLOYEE: 'invite/team_member/reject?',
  REMOTE_AUTH_INFO: 'remote_auth_info',
  REMOVE_CAMPAIGNS_FROM_CANDIDATE: 'candidate/remove_jobs?',
  REMOVE_CANDIDATE_TAG: 'candidate/remove_tag?',
  REMOVE_FACEBOOK_MAPPING: 'facebook/mappings/delete?',
  REMOVE_MULTICANDIDATE_FROM_CAMPAIGN: 'candidate/remove_candidates_from_job?',
  REMOVE_MULTICANDIDATE_FROM_TAGS: 'candidate/remove_tags?',
  REMOVE_PUSH_DEVICE: 'user/remove_push_device',
  REMOVE_TAG: 'tags/remove?',
  REPORT_BASE_URL: 'v1/textrecruit/',
  REGULATORY_BUNDLE_SUBMITTED: 'compliance/submitted',
  REGULATORY_BUNDLE_TOKEN: 'compliance/token',
  SCHEDULED_MESSAGE: 'message/schedule?',
  SCHEDULED_MESSAGES: 'message/scheduled',
  SCHEDULED_MESSAGES_SEARCH: 'message/scheduled/search?',
  SEARCH_ARI_RESPONSES: 'ari/test',
  SEND_INVITE: 'invite/team_member?',
  SEND_MESSAGE: 'message/send_single?',
  SEQUENCES: 'sequences',
  SEQUENCE_CANDIDATE_REPORT: 'metrics/sequence/candidates',
  SEQUENCE_REPORT: 'metrics/sequences',
  SEQUENCE_TYPES: 'sequence/sequence_types',
  UPDATE_SEQUENCE: 'sequence/update?',
  STATISTICS: 'v1/textrecruit/statistics',
  TAG: 'tag?',
  TAGS: 'tags?',
  TEAM: 'team?',
  GET_TEAM: 'team/get?',
  EDIT_TEAM: 'team/edit?',
  DELETE_TEAM: 'team/delete?',
  TEAMS: 'teams?',
  DOWNLOAD_TEAMS: '/reports/exportteamsreport?',
  TEAMS_IMPORT: 'teams/import?',
  TOKEN_INFO: 'user/token_info?',
  UPDATE_BOOKING_SETTINGS: 'events/booking/settings?',
  UPDATE_CAMPAIGN: 'job/update?',
  UPDATE_CANDIDATE: 'candidate/update?',
  UPDATE_FACEBOOK_MAPPING: 'facebook/mappings/update?',
  UPDATE_TAGS: 'tag/update?',
  UPDATE_USER: 'user/update',
  UPDATE_USER_PREFERENCES: 'user/update/preferences?',
  USERS_REPORT: 'reporting/users',
  USER_SEND_AS: 'user/send_as',
  VALIDATE_CANDIDATE: 'candidate/validate?',
  VALIDATE_PHONE_NUMBER: 'number/validate?',
  VERIFY_PASSWORD: 'user/verify_password_ref?',
  WEBSOCKET_ID: '/user/websocket',
  GET_WECHAT_CONFIGURATIONS: 'wechat/config_details?',
  ADD_WECHAT_ACCOUNT: 'wechat/account/save',
  DELETE_WECHAT_ACCOUNT: 'wechat/account/delete',
  DISCONNECT_WAB_ACCOUNT: 'user/disconnect/whatsapp',
  CONNECT_WAB_ACCOUNT: 'user/connect/whatsapp',
  VERIFY_WHATSAPP_NUMBER: 'user/whatsapp/verify',
  UPLOAD_CORPUS_DATA: '/ari/context/file?',
  GET_CORPUS_DATA: '/ari/context',
  DELETE_CORPUS_DATA: '/ari/context/remove',
  DOWNLOAD_CORPUS_DATA: '/ari/context/file-url',
  IMPORT_STRUCTURED_RESPONSE: '/ari/upgrade/import-to-knowledgebase',
  GET_OR_CREATE_DEMO_SEQUENCE: '/ari/recruiting/demo',
  UPGRADE_SEQUENCE_TO_USE_KNOWLEDGE_BASE: '/ari/recruiting/upgrade',
};
